<template>
  <nav class="pure-menu-horizontal">
    <ul>
      <li class="pure-menu-item" v-if="$cookies.get('user')">
        <router-link to="/user"
          ><i class="fa fa-book-reader"></i> My Shelves</router-link
        >
      </li>
      <li class="pure-menu-item" v-else>
        <router-link to="/login"><i class="fa fa-user"></i> Login</router-link>
      </li>
      <li class="pure-menu-item" v-if="$cookies.get('user')">
        <router-link to="/add-book"
          ><i class="fa fa-book"></i> Add a book</router-link
        >
      </li>
      <li class="pure-menu-item" v-if="$cookies.get('user')">
        <router-link to="/add-shelf"
          ><i class="fa fa-book"></i> Add a shelf</router-link
        >
      </li>
      <li class="pure-menu-item" v-if="$cookies.get('user')">
        <a href="/" v-on:click="logout">Log out</a>
      </li>
    </ul>
  </nav>
</template>
<script>
import Vue from 'vue';
import Store from '../store';

export default {
  name: 'page-menu',
  mounted() {
    this.$eventHub.$on('login', (user) => {
      Vue.set(Store, 'user', user);

      this.user = user;

      this.$router.push('dashboard');
    });
  },
  methods: {
    logout() {
      this.$cookies.remove('user');
      this.$router.go('/');
    },
  },
  data() {
    return {
      user: Store.user,
    };
  },
};
</script>
